{
  "$mp-slow-tooltip-delay-in": 750,
  "$mp-default-tooltip-delay-in": 200,
  "$mp-default-tooltip-delay-out": 50,
  "$mp-slow": 400,
  "$mp-fast": 250
}
